import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export function PrepReport({ items = [] }) {
  if (!items.length) return null;
  return (
    <section id="preparation" className="on-dark grain relative bg-forest text-paper" data-testid="prep-report">
      <div className="relative z-[2] grid gap-10 p-5 sm:gap-12 sm:p-10 lg:grid-cols-12 lg:p-14">
        <Reveal className="min-w-0 lg:col-span-5">
          <p className="eyebrow text-stone">The Cirencester Standard</p>
          <h2 className="mt-4 font-serif text-3xl leading-tight sm:text-5xl">Prepared by Cirencester 4x4</h2>
          <p className="mt-5 text-base leading-relaxed text-paper/90 sm:mt-6">“Every vehicle is thoroughly inspected, serviced where required and prepared to a standard we would be happy to drive ourselves.”</p>
          <Link to="/the-cirencester-standard" className="btn btn-ghost-light mt-8 w-full whitespace-normal text-center leading-snug sm:w-auto" data-testid="prep-read-more">Read about our preparation process <ArrowRight className="arrow h-4 w-4 shrink-0" /></Link>
        </Reveal>
        <div className="min-w-0 lg:col-span-7">
          <table className="w-full text-left text-sm" data-testid="prep-table">
            <caption className="sr-only">Preparation report</caption>
            <thead>
              <tr className="border-b border-paper/30 text-[0.7rem] uppercase tracking-[0.16em] text-stone">
                <th scope="col" className="py-3 font-semibold">Item</th>
                <th scope="col" className="py-3 font-semibold">Status</th>
                <th scope="col" className="hidden py-3 font-semibold sm:table-cell">Notes</th>
              </tr>
            </thead>
            <tbody>
              {items.map((r, i) => (
                <tr key={i} className="border-b border-paper/15 align-top" data-testid={`prep-row-${i}`}>
                  <th scope="row" className="w-[38%] py-3.5 pr-4 font-medium sm:w-auto">{r.item}</th>
                  <td className="py-3.5 pr-4">
                    <span className="inline-flex items-center gap-2 font-serif text-lg text-stone">
                      <CheckCircle2 className="h-4 w-4 shrink-0" strokeWidth={1.5} />{r.value || r.status}
                    </span>
                    {r.notes && <span className="mt-1 block text-xs text-paper/80 sm:hidden">{r.notes}</span>}
                  </td>
                  <td className="hidden py-3.5 text-paper/80 sm:table-cell">{r.notes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

export function ServiceTimeline({ entries = [] }) {
  if (!entries.length) return null;
  return (
    <ol className="relative ml-2 border-l border-stone-dark" data-testid="service-timeline">
      {entries.map((e, i) => (
        <Reveal as="li" key={i} delay={i * 0.05} y={16} className="relative pb-10 pl-8 last:pb-0">
          <span className={`absolute -left-[7px] top-1.5 h-3.5 w-3.5 rounded-full border-2 border-paper ${i === 0 ? "bg-forest" : "bg-stone-dark"}`} />
          <p className="eyebrow text-forest">{new Date(e.date).toLocaleDateString("en-GB", { month: "long", year: "numeric" })}{e.mileage ? ` · ${Number(e.mileage).toLocaleString("en-GB")} miles` : ""}</p>
          <p className="mt-1 font-serif text-xl text-charcoal">{e.work}</p>
          <p className="text-sm text-charcoal/75">{e.garage}</p>
        </Reveal>
      ))}
    </ol>
  );
}
